import { ContractStatusEnum, SalesOrderStatusEnum } from '@/graphql/contracts/_generated_/contracts';

export const EDITABLE_STATUS_KEYS: string[] = ['Active', 'ActiveDNR', 'AwaitingApproval'];
export const EDITABLE_VARIABLE_STATUS_KEYS: string[] = [
  ContractStatusEnum.Active,
  ContractStatusEnum.ActiveDNR,
  ContractStatusEnum.AwaitingApproval,
];

export const BILLING_TYPES = [{ formattedType: 'Unit Price Change' }, { formattedType: 'Percentage Change' }];

export type MARKED_INVOICE = { value: string };
export const MARKED_INVOICES: MARKED_INVOICE[] = [{ value: 'Collectible' }, { value: 'Uncollectible' }];

type SALES_ORDER_STATUS = {
  types: SalesOrderStatusEnum[];
  formattedType: string;
};

export const FAILED_TYPE = SalesOrderStatusEnum.SENDING_FAILED ||
  SalesOrderStatusEnum.SENDING_SCHEDULING_FAILED ||
  SalesOrderStatusEnum.SENDING_STOPPED;

export const SALES_ORDER_STATUSES: SALES_ORDER_STATUS[] = [
  {
    types: [
      SalesOrderStatusEnum.SENDING_SCHEDULED,
      SalesOrderStatusEnum.SENDING_PAUSED
    ],
    formattedType: 'Scheduled'
  },
  {
    types: [SalesOrderStatusEnum.SENT],
    formattedType: 'Sent'
  },
  {
    types: [
      SalesOrderStatusEnum.SENDING_FAILED,
      SalesOrderStatusEnum.SENDING_SCHEDULING_FAILED,
      SalesOrderStatusEnum.SENDING_STOPPED
    ],
    formattedType: 'Failed',
  }
];

export const SALES_ORDERS_STATUSES_MAP = {
  [SalesOrderStatusEnum.CREATED]: 'Created',
  [SalesOrderStatusEnum.SENDING_SCHEDULED]: 'Sending Scheduled',
  [SalesOrderStatusEnum.SENDING_PAUSED]: 'Sending Paused',
  [SalesOrderStatusEnum.SENDING_FAILED]: 'Sending Failed',
  [SalesOrderStatusEnum.SENDING_SCHEDULING_FAILED]: 'Sending Scheduling Failed',
  [SalesOrderStatusEnum.SENDING_STOPPED]: 'Sending Stopped',
  [SalesOrderStatusEnum.SENT]: 'Sent',
  [SalesOrderStatusEnum.BILLING_PAUSED]: 'Billing Paused',
};

export const SALES_ORDERS_STATUSES_PASCAL_CASE_MAP = {
  [SalesOrderStatusEnum.CREATED]: 'Created',
  [SalesOrderStatusEnum.SENDING_SCHEDULED]: 'SendingScheduled',
  [SalesOrderStatusEnum.SENDING_PAUSED]: 'SendingPaused',
  [SalesOrderStatusEnum.SENDING_FAILED]: 'SendingFailed',
  [SalesOrderStatusEnum.SENDING_SCHEDULING_FAILED]: 'SendingSchedulingFailed',
  [SalesOrderStatusEnum.SENDING_STOPPED]: 'SendingStopped',
  [SalesOrderStatusEnum.SENT]: 'Sent',
  [SalesOrderStatusEnum.BILLING_PAUSED]: 'BillingPaused',
};

type Color = string;

export type StatusColorSchema = {
  [statusValue: string]: Color;
};

// TAG 4 color system
// https://tag-v4.docs.access-workspace.com/docs/getting-started/colours

export const CONTRACT_STATES_COLORS: StatusColorSchema = {
  AwaitingApproval: '#efa611',
  Active: '#40826b',
  Cancelled: '#d82c0d',
  ActiveDNR: '#973060',
  Expired: '#73808b',
  Inactive: '#555b70',
  Variable: '#e9a42d',
  Terminating: '#E1822E',
  Terminated: '#2f2f2f',
  Merged: '#8F4040'
};

export const VARIABLE_STATES_COLORS: StatusColorSchema = {
  AwaitingApproval: '#efa611',
  Active: '#40826b',
  ActiveDNR: '#973060',
  Inactive: '#555b70',
  Expired: '#73808b',
  Cancelled: '#d82c0d',
  Merged: '#8F4040',
};

export const FILE_STATUS_COLORS: StatusColorSchema = {
  Uploaded: '#7ab4ab',
  Validating: '#efb851',
  Importing: '#eaa82e',
  Processing: '#326654',
  ImportError: '#f2153e',
  ProcessError: '#af0c2a',
  ValidationError: '#f60002',
  Processed: '#007A7A',
  Imported: '#2b889c',
  Validated: '#0d6666',
};

export enum ContractStatuses {
  Active = 'Active',
  DNR = 'ActiveDNR',
  Cancelled = 'Cancelled',
  AwaitingApproval = 'AwaitingApproval',
  Expired = 'Expired',
  Merged = 'Merged'
}

export const VARIABLE_TYPE = 'Variable';
export const NON_VARIABLE_TYPE = 'NonVariable';

export enum BillingCycleStatusFormatted {
  ActivePending = 'Active Pending',
  Excluded = 'Excluded',
  Ignored = 'Ignored',
  SoCreated = 'So Created',
  SoCreationStarted = 'So Creation Started',
}

export const filterPurchaseOrdersStatuses = [
  { label: 'Active', value: 'Active' },
  { label: 'Cancelled', value: 'Cancelled' },
  { label: 'Expired', value: 'Expired' },
];
